export const ignoreDragClass = 'ignore-drag';

export const allowMouseDownEvent = (currentTarget: HTMLElement, target: HTMLElement) => {
    if (currentTarget === target) return true;
    if (target.classList.contains(ignoreDragClass)) {
        return false;
    } else {
        return allowMouseDownEvent(currentTarget, target.parentElement as HTMLElement);
    }
};
